// extracted by mini-css-extract-plugin
export default {"header":"Header_header__6ElLm","logoLink":"Header_logoLink__UuDdQ","logoIcon":"Header_logoIcon__b9Rhm","nav":"Header_nav__hoyQo","link":"Header_link__eqYCL"};